import {AlertFillIcon} from '@primer/octicons-react'
import CircleOcticon from '@github-ui/circle-octicon'
import {HEADER_ICON_SIZE} from '../../../constants'
import styles from '../BlockedSection.module.css'

export function AlertIcon({bgColor}: {bgColor?: string}) {
  return (
    <CircleOcticon
      icon={() => <AlertFillIcon size={16} />}
      size={HEADER_ICON_SIZE}
      style={bgColor ? {backgroundColor: bgColor} : undefined}
      className={styles.CircleOcticon}
    />
  )
}
